<template>
  <div id="administration">
    <AddVehicle ref="vehiclePopin" />
    <DeleteVehicle ref="deleteVehiclePopin" />
    <div id="fleet-selector">
      <select-fleet></select-fleet>
    </div>
    <div class="item-container">
      <v-data-table
        :headers="TableHeader"
        :items="getVehiclesInfo"
        sort-by="name"
        :items-per-page="10"
        class="elevation-1"
        :footer-props="footerProps"
      >
        <template v-slot:[`item.make`]="{ item }">
          <div>
            {{ item.model.make }}
          </div>
        </template>
        <template v-slot:[`item.model`]="{ item }">
          <div>
            {{ item.model.model }}
          </div>
        </template>
        <template v-slot:[`item.soc`]="{ item }">
          <div v-if="item.model.batteryCapacity" class="unselectable">
            {{ Math.round(item.model.batteryCapacity / 1000).toString() }}
          </div>
        </template>
        <template v-slot:[`item.Priority`]="{ item }">
          <v-simple-checkbox
            :value="item.priority !== 0"
            disabled
            color="#10367A"
            :ripple="false"
          ></v-simple-checkbox>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div>
            <v-icon medium class="iconTable" @click="showPopin(item)">
              mdi-pencil-outline
            </v-icon>
            <v-icon medium class="iconTable deleteVehicle" @click="confirmDeleteVehicle(item)">
              mdi-delete-outline</v-icon
            >
          </div>
        </template>
      </v-data-table>
    </div>
    <div id="btn-container">
      <baseButton
        :value="$t('administration.new-vehicle')"
        id="add-button"
        :action="showPopin"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectFleet from '../components/select-fleet'
import AddVehicle from '../components/add-vehicle'
import baseButton from '@/components/base-button.vue'
import DeleteVehicle from '../components/delete-vehicle'
export default {
  components: { DeleteVehicle, SelectFleet, AddVehicle, baseButton },
  data () {
    return {
      TableHeader: [
        { text: this.$t('administration.header-table.name'), align: 'center', value: 'name' },
        { text: this.$t('administration.header-table.vin'), value: 'vin', align: 'center' },
        { text: this.$t('administration.header-table.mark'), value: 'make', align: 'center' },
        { text: this.$t('administration.header-table.model'), value: 'model', align: 'center' },
        { text: this.$t('administration.header-table.battery'), value: 'soc', align: 'center' },
        { text: this.$t('administration.header-table.badge'), value: 'badge', align: 'center' },
        { text: this.$t('administration.header-table.priority'), value: 'Priority', align: 'center' },
        { text: this.$t('administration.header-table.action'), value: 'actions', align: 'center' }
      ],
      footerProps: { 'items-per-page-text': this.$t('administration.footer-vehicle'), 'items-per-page-options': [5, 10, 15, { text: this.$t('administration.footer-elementByPage'), value: -1 }], 'page-text': this.$t('administration.footer-page') },
      disabled: true,
      selectedVehicle: [],
      defaultItem: {}
    }
  },
  computed: {
    ...mapGetters('vehicle', ['getVehiclesInfo'])
  },
  methods: {
    showPopin (item) {
      if (item && item.id) {
        const vehicle = {
          name: item.name,
          vin: item.vin,
          model: item.model,
          make: item.model.make,
          badge: item.badge,
          priority: item.priority !== 0,
          id: item.id
        }
        this.$refs.vehiclePopin.display(vehicle)
      } else {
        this.$refs.vehiclePopin.display()
      }
    },
    confirmDeleteVehicle (item) {
      this.$refs.deleteVehiclePopin.display(item)
    }
  }
}
</script>

<style>
.selectSize {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  width: 150px;
}
.item-container {
  margin-bottom: 35px;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  background: #f9f9f9;
  text-align: center;
}
.v-data-table {
  background: #f2f2f2;
  border: 1px solid #828282;
}

th {
  align-items: center !important;
  background: #10367a;
}
td {
  border: 1px solid #828282;
  color: #10367a;
}
td:nth-last-child(7n),
td:nth-last-child(-7n + 6),
td:nth-last-child(-7n + 5),
td:nth-last-child(-7n + 4) {
  color: rgba(0, 0, 0, 50%);
  background-color: #f2f2f2;
  cursor: grab;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  color: #ffffff !important;
}
.iconTable {
  margin-right: 15px;
}
.v-text-field {
  margin: 0;
  padding: 0;
}
input {
  width: 150px;
  height: 30px;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable.active
  .v-data-table-header__icon,
.v-icon.v-data-table-header__icon::before {
  color: #f9f9f9;
}
.v-icon .disabled {
  cursor: not-allowed !important;
}
.v-btn {
  text-transform: uppercase;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0 10px;
}
.v-input--selection-controls {
  margin-top: 5px;
}
.theme--light.v-icon.v-icon.v-icon--disabled {
  color: #10367a !important;
}
#administration {
  margin-left: 98px;
  margin-right: 98px;
}
#fleet-selector {
  width: 250px;
}

#btn-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  text-transform: none !important;
}

#add-button {
  text-transform: none !important;
}
</style>
